<template>
  <div class="fertilizers">
    <MobileSidebarWrapper param="feltId">
      <template slot="sidebar">
        <bar />
      </template>
      <template slot="content">
        <router-view />
      </template>
    </MobileSidebarWrapper>

    <Popup />
  </div>
</template>

<script>
import Bar from "@/components/fertilizers/bar/Bar";
import Popup from "@/components/fertilizers/popup/Popup";
import MobileSidebarWrapper from "@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      open: true,
    };
  },
  components: {
    Bar,
    Popup,
    MobileSidebarWrapper,
  },
  computed: {
    ...mapGetters({
      id: "fertilizers/getId",
    }),
  },
  methods: {
    //=================================================================================
    updateRouteData() {
      // if (this.$route.params.page) {
      //   this.$store.commit('fertilizers/savePage', this.$route.params.page);
      // }
      if (this.$route.params.type) {
        this.$store.commit("fertilizers/saveType", this.$route.params.type);
      }
      if (this.$route.params.feltId) {
        if (this.id != this.$route.params.feltId) {
          this.$store.commit("fertilizers/saveId", this.$route.params.feltId);
          this.$store.dispatch("fertilizers/getFertilizer")
          .catch(err=>{
             this.$notify({
            group: "notices",
            title: this.$ml.get(`Please buy a plan before selecting fertilizers.`),
            type: "error",
          });
          })
        } else {
          this.$store.dispatch("fertilizers/getFertilizers");
        }
      } else {
        this.$store.dispatch("fertilizers/getFertilizers");
      }
    },
    //=================================================================================
  },
  created() {
    this.updateRouteData();
    this.$store.dispatch("fertilizers/getFertilizers");
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.updateRouteData();
  },
};
</script>

<style lang="scss" scoped>
.fertilizers {
  padding: 8px;
  display: flex;
  align-items: flex-start;
}
</style>
